module.exports = __webpack_public_path__ + "static/media/error.f3fbadd1.gif";